import React, { FC, useCallback, useMemo } from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { financialUrl } from 'common/config/urls';
import { ValuationsParams } from 'pages/ValuationsAllocation/types';
import { getStringValue } from 'utilities';
import { RedirectToFinancialButtonProps } from './types';

const SAVE_FINANCIAL_STATEMENT_LABEL = 'Save Financial Statement';

const RedirectToFinancialButton: FC<RedirectToFinancialButtonProps> = params => {
  const { measurementDateSlug } = params;

  const navigate = useNavigate();

  const { firmSlugParam, companySlugParam } = useParams<ValuationsParams>();

  const financialPageUrl = useMemo(
    () => financialUrl(getStringValue(firmSlugParam), getStringValue(companySlugParam)),
    [companySlugParam, firmSlugParam]
  );

  const redirectToFinancial = useCallback(() => {
    navigate(`${financialPageUrl}?date=${measurementDateSlug}`);
  }, [financialPageUrl, navigate, measurementDateSlug]);

  return (
    <Button color="primary" endIcon={<ArrowBackIcon />} onClick={redirectToFinancial} variant="outlined">
      {SAVE_FINANCIAL_STATEMENT_LABEL}
    </Button>
  );
};

export default RedirectToFinancialButton;
